import React, { useState, useEffect, useRef } from "react";
import { Card, YoutubeCard } from "../../components/card";
import { FormError } from "../../components/Error";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";
import { CircularProgress } from "@material-ui/core";
import emailjs from "@emailjs/browser";
import { AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { FaTwitterSquare } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { Navbar } from "../../components/nav/Navbar";
import AOS from "aos";

const Home = () => {
  const [flashlightSize, setFlashlightSize] = useState(1);

  // Services data array
  const servicesData = [
    {
      title: "Development",
      description:
        "Shape the narrative and visual language before cameras roll.",
      services: [
        "Treatments & pitch decks",
        "Scriptwriting & story editing",
        "Budgeting & scheduling",
        "Location research & casting",
      ],
    },
    {
      title: "Production",
      description: "Full crews and gear for cinematic capture anywhere.",
      services: [
        "Directing & cinematography",
        "Production management",
        "Sound recording",
        "Drone & specialty camera ops",
      ],
    },
    {
      title: "Post‑Production",
      description: "Editorial, finishing, and delivery for every platform.",
      services: [
        "Editing & assistant editorial",
        "Colour grading",
        "VFX & motion graphics",
        "Mastering & versioning",
      ],
    },
    {
      title: "Sound",
      description: "From field to final mix for film, TV, and music.",
      services: [
        "Foley & sound design",
        "Original score & music supervision",
        "ADR & voiceover",
        "5.1/7.1 mix & loudness delivery",
      ],
    },
    {
      title: "Music Visuals",
      description: "Concept-to-cut music videos and performance films.",
      services: [
        "Creative direction",
        "Set design & art direction",
        "Choreography capture",
        "Social-first versions",
      ],
    },
    {
      title: "Studio Rentals",
      description: "Spaces and equipment for indie and commercial shoots.",
      services: [
        "Stage & green screen",
        "Lighting & grip packages",
        "Editorial suites",
        "Audio rooms",
      ],
    },
  ];

  const handleMouseMove = (event) => {
    const mouse_x = event.clientX;
    const mouse_y = event.clientY;

    const fl = document.getElementById("flashlight");
    if (fl) {
      // Keep original positioning logic that works
      fl.style.transform =
        "translate(calc(" +
        mouse_x +
        "px - 50vw), " +
        "calc(" +
        mouse_y +
        "px - 50vh)) scale(" +
        flashlightSize +
        ")";

      // Add movement-based size changes
      const now = Date.now();
      if (window.lastMouseMove) {
        const timeDiff = now - window.lastMouseMove.time;
        if (timeDiff > 0) {
          const distance = Math.sqrt(
            Math.pow(mouse_x - window.lastMouseMove.x, 2) +
              Math.pow(mouse_y - window.lastMouseMove.y, 2)
          );
          const speed = distance / timeDiff;

          // Subtle size variation based on speed
          const newSize = Math.min(1.15, Math.max(0.95, 1 + speed * 0.003));
          setFlashlightSize(newSize);
        }
      }

      window.lastMouseMove = { x: mouse_x, y: mouse_y, time: now };
    }
  };

  const handleMouseEnter = () => {
    // No fade effect needed
  };

  const handleMouseLeave = () => {
    setFlashlightSize(1); // Reset size when leaving
  };

  const [loading, setLoading] = useState(false);
  const scrollContainerRef1 = useRef(null);
  const scrollContainerRef2 = useRef(null);

  // Auto-scroll functionality
  useEffect(() => {
    const autoScroll = (containerRef, initialDirection = 1) => {
      if (containerRef.current) {
        const container = containerRef.current;
        const scrollAmount = 1; // pixels per interval
        let direction = initialDirection;

        const scroll = () => {
          const maxScroll = container.scrollWidth - container.clientWidth;

          // Check if we've reached the end (right side)
          if (container.scrollLeft >= maxScroll && direction > 0) {
            direction = -1; // Reverse to scroll left
          }
          // Check if we've reached the beginning (left side)
          else if (container.scrollLeft <= 0 && direction < 0) {
            direction = 1; // Reverse to scroll right
          }

          container.scrollLeft += scrollAmount * direction;
        };

        return setInterval(scroll, 30); // Smooth scrolling every 30ms
      }
    };

    // Start auto-scroll for both containers (opposite initial directions for variety)
    const interval1 = autoScroll(scrollContainerRef1, 1);
    const interval2 = autoScroll(scrollContainerRef2, -1);

    // Cleanup intervals on component unmount
    return () => {
      if (interval1) clearInterval(interval1);
      if (interval2) clearInterval(interval2);
    };
  }, []);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      company: "",
      serviceInterest: "",
      projectBrief: "",
    },
    validationSchema: yup.object({
      name: yup.string().required("Name is required"),
      email: yup.string().email().required("Email is required"),
      company: yup.string().required("Company/Organization is required"),
      serviceInterest: yup.string().required("Service Interest is required"),
      projectBrief: yup.string().required("Project Brief is required"),
    }),

    onSubmit: (prop) => {
      let templateParams = prop;
      templateParams.to_name = "Remigius";
      templateParams.from_name = prop.email;

      setLoading(true);

      emailjs
        .send(
          "service_stlrfhk",
          "template_ri7zico",
          templateParams,
          "23onJtMeeTiF8Y7GB"
        )
        .then(
          (response) => {
            console.log("SUCCESS!", response.status, response.text);

            toast.success("Email sent successfully", {
              duration: 3000,
            });

            formik.setValues((values) => ({
              ...values,
              name: "",
              email: "",
              company: "",
              serviceInterest: "",
              projectBrief: "",
            }));
          },
          (err) => {
            console.log("FAILED...", err);
          }
        );

      // dispatch(loginRequest(prop));

      setLoading(false);
    },
  });

  return (
    <div>
      <Navbar />
      <section className="h-[40vh] lg:h-[80vh] relative bg-primary flex flex-col justify-between overflow-hidden">
        <video
          className="w-full h-full object-cover absolute hidden lg:block"
          preload="metadata"
          id="promo-video"
          autoPlay={true}
          poster="/videos/promo-poster.png"
          loop="loop"
          muted="muted"
        >
          <source
            src="/video/reels.mp4"
            type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'
          />
          The video tag is not supported by your browser :(
        </video>

        <iframe
          className="w-full h-full object-cover absolute block lg:hidden"
          src="https://www.youtube.com/embed/wXinUDqOZGY"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>

        <div className="container mx-auto px-4 py-8 flex flex-col   lg:flex-row  justify-between relative mt-auto">
          <h4 className="font-bodyRegular font-bold text-sm md:text-base text-white">
            Owning The Narrative
          </h4>
          <div className=" px-4 bg-black  w-[200px] rounded-xl flex items-center justify-center gap-x-6 text-white text-2xl md:text-3xl">
            <a
              className="hover:scale-105 transition-all duration-500"
              href={"https://www.instagram.com/afrochives/"}
              target="_blank"
            >
              {" "}
              <AiFillInstagram />
            </a>
            <a
              className="hover:scale-105 transition-all duration-500"
              href={"https://twitter.com/afrochives"}
              target="_blank"
            >
              {" "}
              <FaTwitterSquare />
            </a>
            <a
              className="hover:scale-105 transition-all duration-500"
              href={"https://www.youtube.com/@afrochives"}
              target="_blank"
            >
              {" "}
              <AiFillYoutube />
            </a>
            <a className="hover:scale-105 transition-all duration-500">
              <IoMdMail />
            </a>
          </div>
        </div>
      </section>

      <div className="relative">
        <img src="/img/pattern/pattern.svg"></img>
      </div>

      <section className="py-16 lg:py-24 bg-black">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* About Us Header */}
            <div className="text-center mb-12 lg:mb-10">
              <h2 className="font-head text-4xl lg:text-7xl text-white mb-8">
                ABOUT US
              </h2>
            </div>

            {/* About Content */}
            <div className="flex flex-col justify-center items-center">
              {/* Main Description */}
              <div className="space-y-6 max-w-4xl">
                <p className="font-bodyLight text-base lg:text-base text-gray-200 leading-loose">
                  Afrochives Studio is a media and content production company{" "}
                  <span className="text-white font-medium">
                    redefining African storytelling
                  </span>{" "}
                  by placing people of African origin and descent at the heart
                  of everything we create.
                </p>

                <p className="font-bodyLight text-base lg:text-base text-gray-200 leading-loose">
                  We craft films, documentaries, short-form content, music
                  visuals, and sound experiences that capture the{" "}
                  <span className="text-white font-medium">
                    richness, diversity, and depth
                  </span>{" "}
                  of Afrocentric realities.
                </p>

                <p className="font-bodyLight text-base lg:text-base text-gray-200 leading-loose">
                  Independent yet globally minded, we collaborate with brands,
                  creators, and communities who value{" "}
                  <span className="text-white font-medium">
                    authenticity, craft, and meaningful impact
                  </span>
                  .
                </p>
              </div>

              {/* Ethos Section */}
              <div className=" rounded-lg p-8 lg:p-10">
                <h3 className="font-head text-center text-2xl lg:text-3xl text-white mb-6">
                  Our Ethos
                </h3>
                <div className="flex flex-wrap gap-x-8 gap-y-4 justify-center lg:justify-start">
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-white rounded-full flex-shrink-0"></div>
                    <span className="font-bodyRegular text-gray-200">
                      Authenticity
                    </span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-white rounded-full flex-shrink-0"></div>
                    <span className="font-bodyRegular text-gray-200">
                      Excellence
                    </span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-white rounded-full flex-shrink-0"></div>
                    <span className="font-bodyRegular text-gray-200">
                      Inclusivity
                    </span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-white rounded-full flex-shrink-0"></div>
                    <span className="font-bodyRegular text-gray-200">
                      Sustainability
                    </span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-2 h-2 bg-white rounded-full flex-shrink-0"></div>
                    <span className="font-bodyRegular text-gray-200">
                      Reach
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="relative">
        <img src="/img/pattern/pattern.svg"></img>
      </div>

      <section className="py-16 lg:py-24 bg-white">
        <div className="container mx-auto px-4">
          {/* Services Header */}
          <div className="text-center mb-16">
            <h2 className="font-head uppercase text-4xl lg:text-7xl text-black mb-6">
              SERVICES
            </h2>
            <p className="font-bodyRegular text-base text-gray-600 max-w-4xl mx-auto mb-8">
              From concept to final cut, we provide full-scale production and
              post-production for films, documentaries, short-form stories,
              music, and brand collaborations.
            </p>
            <a
              href="mailto:info@afrochives.studio?subject=Quote Request"
              className="inline-block bg-black text-white rounded-lg px-8 py-4 text-sm lg:text-base font-bodyRegular  hover:bg-white hover:border hover:border-black hover:text-black  transition-all duration-500"
            >
              Get a Quote
            </a>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8 lg:gap-12">
            {servicesData.map((service, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-lg shadow-md p-6 lg:p-8"
              >
                <h3 className="text-2xl font-bodyRegular lg:text-2xl text-black mb-4">
                  {service.title}
                </h3>
                <p className="font-bodyLight text-base text-gray-600 mb-6">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.services.map((item, itemIndex) => (
                    <li
                      key={itemIndex}
                      className="font-bodyRegular text-sm text-gray-700"
                    >
                      • {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About us section */}

      <section
        id="about"
        className="h-[70vh] lg:h-[100vh] py-32 lg:py-32 relative overflow-hidden"
        onMouseMove={(e) => handleMouseMove(e)}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="absolute grid grid-cols-2 md:grid-cols-4 top-0 left-0">
          <img className="" src="/img/bg/glowbg1.png" />
          <img className="" src="/img/bg/glowbg1.png" />
          <img className="" src="/img/bg/glowbg1.png" />
          <img className="" src="/img/bg/glowbg1.png" />
          <img className="" src="/img/bg/glowbg1.png" />
          <img className="" src="/img/bg/glowbg1.png" />
          <img className="" src="/img/bg/glowbg1.png" />
          <img className="" src="/img/bg/glowbg1.png" />
        </div>

        <div id="flashlight"></div>

        <div className="container  lg:h-[70vh] mx-auto relative flex flex-col gap-y-4 items-center justify-between">
          <div className="text-center space-y-6 lg:space-y-8">
            <h3 className="font-head uppercase text-white text-2xl md:text-4xl lg:text-6xl xl:text-7xl leading-tight lg:leading-tight">
              <span className="block">Original stories.</span>
              <span className="block">World-class production.</span>
              <span className="block text-gray-300">Timeless impact.</span>
            </h3>
            <div className="max-w-4xl mx-auto px-4">
              <p className="font-bodyLight text-base md:text-lg lg:text-xl text-gray-200 leading-relaxed lg:leading-relaxed">
                Afrochives Studio is a creative media house bringing{" "}
                <span className="text-white font-medium">
                  Afrocentric stories
                </span>{" "}
                to life through films, documentaries, music visuals, and
                immersive sound.
              </p>
              <p className="font-bodyLight text-base md:text-lg lg:text-xl text-gray-200 leading-relaxed lg:leading-relaxed mt-4">
                From concept to final master, our team delivers productions that{" "}
                <span className="text-white font-medium">
                  inform, educate, entertain, and inspire
                </span>{" "}
                — crafted with precision and rooted in soul.
              </p>
            </div>
          </div>

          <img className="w-12 lg:mt-auto" src="/img/icon/mask.svg" />
        </div>
      </section>

      <section>
        <div className="container mx-auto p-2 bg-[#D9D9D9] mt-10 rounded-lg flex flex-col gap-y-2">
          <div className="flex flex-col gap-y-3 lg:flex-row  gap-x-6 py-5 lg:py-3 p-3 bg-[#FBF8F8] rounded-lg">
            <div className="self-center items-center lg:max-w-[200px]">
              <div className=" hidden lg:block">
                <h3 className="font-head text-5xl lg:text-6xl text-center mx-auto">
                  OUR
                </h3>
                <h3 className="font-head text-5xl lg:text-6xl text-center mx-auto">
                  WORK
                </h3>
              </div>

              <div className="block lg:hidden">
                <h3 className="font-head text-5xl lg:text-6xl text-center mx-auto">
                  OUR WORK
                </h3>
              </div>
              <p className="font-bodyLight text-xs mt-4 text-center lg:text-right">
                Selected Afrochives originals and client collaborations across
                film, short form video, documentary, music, and sound.
              </p>
            </div>
            <div
              ref={scrollContainerRef1}
              className="overflow-x-scroll rounded-lg flex gap-x-3 gap-y-4 scrollbar-hide"
              style={{ scrollBehavior: "smooth" }}
            >
              <YoutubeCard
                videosrc={"https://www.youtube.com/embed/IoV36M6NHBE"}
              />
              <YoutubeCard
                videosrc={"https://www.youtube.com/embed/-DecH5mejPU"}
              />
              <YoutubeCard
                videosrc={"https://www.youtube.com/embed/NnmqF_rn5h0"}
              />
              <YoutubeCard
                videosrc={"https://www.youtube.com/embed/sH-UDp3kbXc"}
              />
            </div>
          </div>
          <div className="flex flex-col-reverse gap-y-3 lg:flex-row  gap-x-6 py-5 lg:py-3 p-3 bg-[#D9ECF4] rounded-lg">
            <div
              ref={scrollContainerRef2}
              className="overflow-x-scroll rounded-lg flex gap-x-3 gap-y-4 scrollbar-hide"
              style={{ scrollBehavior: "smooth" }}
            >
              <YoutubeCard
                videosrc={"https://www.youtube.com/embed/I-LUEED_njo"}
              />
              <YoutubeCard
                videosrc={"https://www.youtube.com/embed/7JGm83eGauc"}
              />
              <YoutubeCard
                videosrc={"https://www.youtube.com/embed/Pd1HVp8eD2U"}
              />
              <YoutubeCard
                videosrc={"https://www.youtube.com/embed/0SZ016XLcEk"}
              />
            </div>

            <div className="self-center items-center lg:max-w-[200px]">
              <div className=" hidden lg:block">
                <h3 className="font-head text-5xl lg:text-6xl text-center mx-auto uppercase">
                  AFROCHIVES
                </h3>
                <h3 className="font-head text-5xl lg:text-6xl text-center mx-auto uppercase">
                  Junior
                </h3>
              </div>

              <div className="block lg:hidden">
                <h3 className="font-head text-5xl lg:text-6xl text-center mx-auto uppercase">
                  Afrochives Junior
                </h3>
              </div>

              <p className="font-bodyLight text-xs text-center lg:text-left mt-4">
                Afrochives Junior is home to the best entertainment for
                children. We bring an original and entertaining blend of
                animations and live action segments to unlock imagination and
                curiosity.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="pt-12 lg:pt-20">
        <div className="container mx-auto text-center px-4">
          <h3 className="font-head text-5xl lg:text-7xl text-center">NEWS</h3>
          <div className=" grid grid-cols-1 lg:grid-cols-3 gap-x-4 gap-y-4 max-w-6xl mx-auto">
            <Card
              head={"PRESS RELEASE."}
              body={
                "Aspiring Filmmakers Wanted: Afrochives Studio Opens Applications for Cohort 1 of Okike Lab, a Transformative Creative Programme.... "
              }
              href={"https://medium.com/@afrochives/press-release-81c475176bc6"}
              imgsrc={"/img/news/news4.jpg"}
            />
            <Card
              head={"Casting Call | Afrochives Studio."}
              body={
                "PRODUCTION DESCRIPTION: Casting a paranormal-horror film about some teenage girls who unwittingly encounter a paranormal entity during one of their juvenile escapades... "
              }
              href={
                "https://medium.com/@afrochives/casting-call-afrochives-studio-d8e1274ec704"
              }
              imgsrc={"/img/news/news5.jpg"}
            />
            <Card
              head={"Introducing Afrochives Studio..."}
              body={
                "We are thrilled to announce the launch of Afrochives Studio, a dynamic media and content studio dedicated to informing, educating, entertaining, and inspiring audiences worldwide... "
              }
              href={
                "https://medium.com/@afrochives/introducing-afrochives-studio-amplifying-afro-centric-stories-for-global-audiences-900c42981bcc"
              }
              imgsrc={"/img/news/news3.png"}
            />
            {/* <Card
              head={"Afrochives Studio partners..."}
              body={
                "In an exciting collaboration that is set to captivate audiences worldwide, Afrochives Studio and Crater Library & Publishers have announced a groundbreaking partnership for... "
              }
              href={
                "https://medium.com/@afrochives/afrochives-studio-partners-with-crater-library-publishers-for-the-animation-production-of-their-238a296b6d96"
              }
              imgsrc={"/img/news/news1.jpg"}
            />
            <Card
              head={"Afrochives Studio and Flocker..."}
              body={
                "Flocker Records, an Independent Record Label specializing in recording, shooting, and production of various media content, has announced a strategic partnership with... "
              }
              href={
                "https://medium.com/@afrochives/afrochives-studio-and-flocker-records-partners-for-latino-perricos-lost-boy-album-release-b595d41288cb"
              }
              imgsrc={"/img/news/news2.png"}
            /> */}
          </div>

          <a
            href="https://medium.com/@afrochives"
            target="_blank"
            className="bg-black w-[150px] mx-auto text-white rounded-lg flex items-center justify-center py-3 lg:py-3 text-xs lg:text-sm font-bodyRegular mt-10 hover:bg-white hover:border hover:border-black hover:text-black transition-all duration-500"
          >
            Read more
          </a>
        </div>
      </section>

      <section id="contact" className="pt-20 lg:py-32">
        <div className="container mx-auto text-center px-4">
          <h3 className="font-head text-4xl lg:text-7xl text-center">
            CONTACT US
          </h3>
          <p className="font-bodyRegular text-xs mb-8 mt-4 text-center ">
            Tell us about your project.
            <br />
            We typically reply within one business day.
          </p>
          <div data-aos="fade-up" className="max-w-xl mx-auto">
            <div className="w-full mt-3">
              <input
                className={`border rounded font-bodyRegular text-xs w-full py-3 px-4 focus:outline-none transition-all duration-300 ${
                  formik.errors.name && formik.touched.name
                    ? "border-red-400 bg-red-50 focus:border-red-500 focus:ring-1 focus:ring-red-200"
                    : "border-[#868585] bg-[#F4F3F3] focus:border-gray-600 hover:border-gray-500"
                }`}
                type={"text"}
                {...formik.getFieldProps("name")}
                placeholder="Your name"
                required
              />
              {formik.errors.name && formik.touched.name && (
                <div className="flex items-center mt-1  text-xs animate-fadeIn">
                  <svg
                    className="w-3 h-3 mr-1 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>{formik.errors.name}</span>
                </div>
              )}
            </div>
            <div className="w-full mt-3">
              <input
                className={`border rounded font-bodyRegular text-xs w-full py-3 px-4 focus:outline-none transition-all duration-300 ${
                  formik.errors.email && formik.touched.email
                    ? "border-red-400 bg-red-50 focus:border-red-500 focus:ring-1 focus:ring-red-200"
                    : "border-[#868585] bg-[#F4F3F3] focus:border-gray-600 hover:border-gray-500"
                }`}
                type={"email"}
                {...formik.getFieldProps("email")}
                placeholder="Your email"
                required
              />
              {formik.errors.email && formik.touched.email && (
                <div className="flex items-center mt-1  text-xs animate-fadeIn">
                  <svg
                    className="w-3 h-3 mr-1 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>{formik.errors.email}</span>
                </div>
              )}
            </div>
            <div className="w-full mt-3">
              <input
                className={`border rounded font-bodyRegular text-xs w-full py-3 px-4 focus:outline-none transition-all duration-300 ${
                  formik.errors.company && formik.touched.company
                    ? "border-red-400 bg-red-50 focus:border-red-500 focus:ring-1 focus:ring-red-200"
                    : "border-[#868585] bg-[#F4F3F3] focus:border-gray-600 hover:border-gray-500"
                }`}
                type={"text"}
                {...formik.getFieldProps("company")}
                placeholder="Your company/organization"
                required
              />
              {formik.errors.company && formik.touched.company && (
                <div className="flex items-center mt-1  text-xs animate-fadeIn">
                  <svg
                    className="w-3 h-3 mr-1 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>{formik.errors.company}</span>
                </div>
              )}
            </div>
            <div className="w-full mt-3">
              <select
                className={`border rounded font-bodyRegular text-xs w-full py-3 px-4 focus:outline-none transition-all duration-300 ${
                  formik.errors.serviceInterest &&
                  formik.touched.serviceInterest
                    ? "border-red-400 bg-red-50 focus:border-red-500 focus:ring-1 focus:ring-red-200"
                    : "border-[#868585] bg-[#F4F3F3] focus:border-gray-600 hover:border-gray-500"
                }`}
                {...formik.getFieldProps("serviceInterest")}
                required
              >
                <option value="">Select service interest</option>
                <option value="Production">Production</option>
                <option value="Post-Production">Post-Production</option>
                <option value="Sound">Sound</option>
                <option value="Animation">Animation</option>
                <option value="Documentary">Documentary</option>
                <option value="Music Video">Music Video</option>
                <option value="Commercial">Commercial</option>
                <option value="Other">Other</option>
              </select>
              {formik.errors.serviceInterest &&
                formik.touched.serviceInterest && (
                  <div className="flex items-center mt-1  text-xs animate-fadeIn">
                    <svg
                      className="w-3 h-3 mr-1 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>{formik.errors.serviceInterest}</span>
                  </div>
                )}
            </div>
            <div className="w-full mt-3">
              <textarea
                className={`border h-[120px] rounded font-bodyRegular text-xs w-full py-3 px-4 focus:outline-none resize-none transition-all duration-300 ${
                  formik.errors.projectBrief && formik.touched.projectBrief
                    ? "border-red-400 bg-red-50 focus:border-red-500 focus:ring-1 focus:ring-red-200"
                    : "border-[#868585] bg-[#F4F3F3] focus:border-gray-600 hover:border-gray-500"
                }`}
                {...formik.getFieldProps("projectBrief")}
                placeholder="Tell us about your project brief..."
                required
              />
              {formik.errors.projectBrief && formik.touched.projectBrief && (
                <div className="flex items-center mt-1  text-xs animate-fadeIn">
                  <svg
                    className="w-3 h-3 mr-1 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>{formik.errors.projectBrief}</span>
                </div>
              )}
            </div>

            <p className="text-xs text-gray-600 mt-4 text-center font-bodyLight">
              By sending, you agree to our terms and privacy policy.
            </p>

            <div
              onClick={formik.handleSubmit}
              className="bg-black text-white rounded-lg flex items-center justify-center py-3 text-sm font-bodyRegular mt-4 hover:bg-white hover:border hover:border-black hover:text-black transition-all duration-500 cursor-pointer"
            >
              {loading ? (
                <CircularProgress size={20} color="white" />
              ) : (
                "Send Inquiry"
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="pt-4  pb-16">
        <div className="container mx-auto text-center px-4">
          <h2 className="font-head text-4xl lg:text-6xl text-center mb-6 uppercase">
            Ready to create something iconic?
          </h2>
          <p className="font-bodyLight text-lg lg:text-xl text-center max-w-3xl mx-auto mb-8">
            Partner with Afrochives Studio for development, production, and
            post-production.
          </p>
          <a
            href="tel:+2348078557584"
            className="inline-block bg-black text-white rounded-lg px-8 py-4 text-sm lg:text-base font-bodyRegular hover:bg-white hover:border hover:border-black hover:text-black transition-all duration-500"
          >
            Book a Call
          </a>
        </div>
      </section>

      <section>
        <div className="container mx-auto py-8 px-4">
          {/* Contact Information */}
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-y-6 lg:gap-y-0 mb-8">
            <div className="flex flex-col gap-y-2">
              <h4 className="font-bodyRegular text-sm font-bold">Contact</h4>
              <a
                href="mailto:info@afrochives.studio"
                className="font-bodyRegular text-xs hover:underline"
              >
                info@afrochives.studio
              </a>
              <a
                href="tel:+2348078557584"
                className="font-bodyRegular text-xs hover:underline"
              >
                +234 8078557584
              </a>
              <p className="font-bodyRegular text-xs text-gray-600">
                Enugu • Nigeria • Remote
              </p>
            </div>

            <div className="flex gap-x-6 text-black text-3xl">
              <a
                className="hover:scale-105 transition-all duration-500"
                href={"https://www.instagram.com/afrochives/"}
                target="_blank"
              >
                <AiFillInstagram />
              </a>
              <a
                className="hover:scale-105 transition-all duration-500"
                href={"https://twitter.com/afrochives"}
                target="_blank"
              >
                <FaTwitterSquare />
              </a>
              <a
                className="hover:scale-105 transition-all duration-500"
                href={"https://www.youtube.com/@afrochives"}
                target="_blank"
              >
                <AiFillYoutube />
              </a>
              <a
                href="mailto:info@afrochives.studio"
                className="hover:scale-105 transition-all duration-500"
              >
                <IoMdMail />
              </a>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="border-t border-gray-200 pt-6 flex flex-col lg:flex-row justify-between items-center gap-y-4">
            <h4 className="font-bodyRegular text-xs">
              Powered by Greysoft Solutions LTD
            </h4>
            <h4 className="font-bodyRegular text-xs text-center lg:text-left max-w-xl">
              © 2023 Afrochives. All rights reserved. Art Work by Oji Chiagoziem
              Nneamaka.
            </h4>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
